import React from 'react';

const LabOrderItemKeyValueMobile = (props) => {
    const {meta_data} = props;
    if(Object.entries(meta_data).length > 0 && meta_data !== null){
        return (
            <>
                <div className="key-value-details-holder-mobile">
                    {
                        Object.entries(meta_data).map((value, index) => {
                            if(typeof value[1]['value'] === "number") {
                                return (
                                    <div className="key-value-item-mobile" key={index}>
                                    <div className="key">{value[1]['title']}</div>
                                    <div className="line-lab-mobile"></div>
                                    <div className="price-container-mobile">
                                        <div className="value">{value[1]['value']}</div>
                                        <div className="unit">تومان</div>
                                    </div>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="key-value-item-mobile" key={index}>
                                    <div className="key more-info">{value[1]['title']}</div>
                                    <div className="line-lab-mobile"></div>
                                <div className="price-container-mobile">
                                    <div className="value more-info">{value[1]['value']}</div>
                                </div>
                                </div>
                                )
                            }
                        })
                    }
                </div>
            </>
        )
    }else{
        return null;
    }
};

export default LabOrderItemKeyValueMobile;